import React from 'react'

const PaymentActivity = () => {
  return (
    <>
      <section>
        <h1>Payment Activity</h1>
      </section> 
    </>
  )
}

export default PaymentActivity
